import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { base44 } from "@/api/base44Client";

// Cache the auth check result for the session to avoid repeated API calls
let cachedAuth = null;
let cacheTime = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export default function AdminGuard({ children }) {
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    const now = Date.now();

    // Use cached result if still valid
    if (cachedAuth && (now - cacheTime) < CACHE_TTL) {
      if (cachedAuth.valid) {
        setChecking(false);
      } else {
        navigate("/admin/login");
      }
      return;
    }

    base44.auth.me()
      .then(me => {
        if (!mounted.current) return;
        if (!me || me.role !== "admin") {
          cachedAuth = { valid: false };
          cacheTime = Date.now();
          navigate("/admin/login");
        } else {
          cachedAuth = { valid: true };
          cacheTime = Date.now();
          setChecking(false);
        }
      })
      .catch(() => {
        if (!mounted.current) return;
        cachedAuth = { valid: false };
        cacheTime = Date.now();
        navigate("/admin/login");
      });

    return () => { mounted.current = false; };
  }, []);

  if (checking) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-background">
        <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return children;
}

// Call this on logout to clear the cache
export function clearAdminAuthCache() {
  cachedAuth = null;
  cacheTime = 0;
}